import React from 'react';
import styled from 'styled-components';
import mainvisual_d from '../assets/mainvisual_d.png';
import mainvisual_m from '../assets/mainvisual_m.png';

const BannerWrapper = styled.div`
  img {
    max-width: 100%;

    :last-child {
      display: none;
    }
  }

  @media screen and (max-width: 499px) {
    width: 100%;
    img {
      :first-child {
        display: none;
      }
      :last-child {
        width: 100%;
        display: block;
      }
    }
  }

  @media screen and (max-width: 1199px) {
    width: 100%;
    img {
      /* max-width: unset; */
    }
  }
`;

const Banner = () => {
  return (
    <BannerWrapper>
      <img src={mainvisual_d} alt="mainvisual_d" />
      <img src={mainvisual_m} alt="mainvisual_m" />
    </BannerWrapper>
  );
};

export default Banner;
